import type { FormField } from '../typings';

/** Keys under which a form-tree node holds an array of child fields. */
export const FORM_FIELD_CHILD_LIST_KEYS = [
  'fields',
  'firstStageFields',
  'otherFields',
  'children',
] as const;

/** Keys under which a form-tree node holds a single nested field. */
export const FORM_FIELD_CHILD_SINGLE_KEYS = [
  'naDetails',
  'notApplicableField',
  'field',
  'trueDetails',
  'falseDetails',
  'matchingDetails',
  'conditionField',
] as const;

/** Visits every field in the tree pre-order, through each shared child key. */
export const forEachFormField = (
  fields: readonly FormField[],
  visit: (field: FormField) => void,
): void => {
  for (const field of fields) {
    if (!field || typeof field !== 'object') continue;

    visit(field);

    const record = field as unknown as Record<string, unknown>;

    for (const key of FORM_FIELD_CHILD_LIST_KEYS) {
      const value = record[key];
      if (Array.isArray(value)) forEachFormField(value as FormField[], visit);
    }

    for (const key of FORM_FIELD_CHILD_SINGLE_KEYS) {
      const value = record[key];
      if (value && typeof value === 'object') {
        forEachFormField([value as FormField], visit);
      }
    }
  }
};
